import clsx from 'clsx'
import { Button, Checkbox, Modal } from 'avo-ui'
import icX from '../../../assets/images/ic-x.svg'
import icFilter from '../../../assets/images/ic-filter.svg'
import icFilterWhite from '../../../assets/images/ic-filter-white.svg'
import { useEffect, useState } from 'react'
import { capitalize } from 'utils/utils'
import { FixedSizeList as List } from 'react-window'

const Filter = ({ className, show, setShow, options, values = {}, onSubmit }) => {
    const [checkList, setCheckList] = useState({})

    const getFilterCount = () => {
        let count = 0
        Object.keys(values).map((i) => (count += values[i]?.length))
        return count
    }

    const isChecked = (key, value) => {
        return checkList[key]?.includes(value?.toString())
    }

    const checkedHandler = (key, item) => {
        let newData
        if (item?.checked) {
            newData = checkList[key] ? [...checkList[key]] : []
            newData.push(item?.value)
        } else {
            newData = checkList[key]?.filter((i) => i !== item?.value)
        }
        setCheckList({ ...checkList, [key]: newData })
    }

    const onSubmitHandler = () => {
        if (onSubmit) onSubmit(checkList)
        setShow(false)
    }

    useEffect(() => {
        setCheckList(values)
    }, [show])

    return (
        <>
            <div className={'w-fit relative'}>
                <Button
                    className={clsx(getFilterCount() > 0 && '!bg-blue-90 !text-white')}
                    title={'Filter'}
                    icon={getFilterCount() > 0 ? icFilterWhite : icFilter}
                    type={'outline'}
                    onClick={() => setShow(!show)}
                />
                <div
                    className={`absolute -right-1 -top-3.5 py-1 px-2.5 text-white bg-blue-95 rounded-full ${getFilterCount() > 0 ? 'block' : 'hidden'}`}
                >
                    {getFilterCount()}
                </div>
            </div>
            <Modal
                dialogClassName={clsx('w-[328px]', className)}
                contentClassName={'rounded-xl'}
                show={show}
                onHide={() => setShow(false)}
            >
                <div className={'flex flex-row px-3 py-5 items-center justify-between'}>
                    <div />
                    <p className={'font-semibold'}>Filter</p>
                    <img className={'w-5 -mt-8 cursor-pointer'} src={icX} alt='ic-x' onClick={() => setShow(false)} />
                </div>
                <div className={'flex flex-col max-h-48 overflow-scroll'}>
                    {options?.map((item, index) => (
                        <div key={index} className={'space-y-3 mb-5 pl-5'}>
                            <p className={'font-semibold text-blue-90 capitalize'}>{item?.title}</p>
                            <List
                                className={item?.list?.length ? 'block' : 'hidden'}
                                height={Math.min(item?.list?.length * 30, 200)} // Maksimum tinggi
                                itemCount={item?.list?.length}
                                itemSize={30} // Tinggi setiap item
                                width='100%'
                            >
                                {({ index, style }) => {
                                    const i = item?.list[index]
                                    return (
                                        <div key={item?.key} style={style}>
                                            <Checkbox
                                                key={`${i?.value}-${index.toString()}`}
                                                label={capitalize(i?.name)}
                                                name={i?.title}
                                                value={i?.value}
                                                checked={isChecked(item?.key, i?.value)}
                                                onChange={(value) => checkedHandler(item?.key, value)}
                                            />
                                        </div>
                                    )
                                }}
                            </List>
                        </div>
                    ))}
                </div>
                <div className={'flex flex-row px-6 py-3 space-x-3 justify-center'}>
                    <Button type={'outline'} title={'Cancel'} onClick={() => setShow(false)} />
                    <Button title={'Submit'} onClick={onSubmitHandler} />
                </div>
            </Modal>
        </>
    )
}

export default Filter
